import { useEffect, useState } from "react";
import { navigate } from "@reach/router";
import { connect } from "react-redux";

import BlurCompany from "./blur-image.png";
import { PageWrap } from "../components/Layout";
import { SideDraw } from "../components/SideDraw";
import {
	getCompanyView,
	getDocuments,
	getDocumentAccessRequests,
	getPastProjects,
} from "../actions/companyActions";
import { AdditionalProfilesModal } from "../components/GuestModal/AdditionalProfilesModal";
import { ACCOUNT_TYPES_GROUPING } from "../constants/profileTypes";
import { useCurrentCompanyValue, useCurrentUser } from "hooks/auth";
import { AppMenu } from "newui/features/AppMenu";
import { CompanyPreview } from "newui/features/Company/CompanyProfile/Preview";

const PaidProfileWrapper = () => (
	<div
		className="fixed inset-0 min-h-full min-w-full"
		style={{ background: `url(${BlurCompany})`, backgroundSize: "cover" }}
	/>
);

export const CompanyComponent = ({
	getCompanyView,
	getDocuments,
	getDocumentAccessRequests,
	getPastProjects,
	companyId,
	company,
	loading,
	...props
}) => {
	const [statusCode, setStatusCode] = useState();
	let pathname = window.location.pathname;
	pathname = pathname.replace("/company/", "");
	let idCompanyFromURL = pathname.replace("/projects", "");
	const isOwnCompany = parseInt(idCompanyFromURL) === company?.id;
	const { isSuperAdmin } = useCurrentUser();

	const accountTypeId = useCurrentCompanyValue("plan")?.id;
	const currentCompanyGrouping = useCurrentCompanyValue("grouping");
	const dataCompanyGrouping = company?.grouping;
	const [isAdditionalProfileModalOpen, setIsAdditionalProfileModalOpen] =
		useState(true);

	useEffect(() => {
		if (companyId) {
			async function fetchData() {
				const res = await getCompanyView(companyId);
				setStatusCode(res?.status);
			}
			fetchData();
			getDocuments(companyId);
			getDocumentAccessRequests(companyId);
			getPastProjects(companyId, true);
		}
	}, [getCompanyView, getDocuments, getDocumentAccessRequests, getPastProjects, companyId]);

	useEffect(() => {
		setIsAdditionalProfileModalOpen(statusCode === 403);
	}, [statusCode]);

	useEffect(() => {
		if (isSuperAdmin || !isOwnCompany) {
			return;
		}

		if (
			currentCompanyGrouping === ACCOUNT_TYPES_GROUPING.procurer &&
			currentCompanyGrouping === dataCompanyGrouping
		) {
			navigate("/404");
		} else if (
			currentCompanyGrouping === ACCOUNT_TYPES_GROUPING.bidderAndProcurer &&
			currentCompanyGrouping === ACCOUNT_TYPES_GROUPING.procurer
		) {
			navigate("/404");
		} else {
			if (
				!currentCompanyGrouping ===
				ACCOUNT_TYPES_GROUPING.bidderAndProcurer ||
				!currentCompanyGrouping === ACCOUNT_TYPES_GROUPING.procurer
			) {
				navigate("/404");
			}
		}
	}, [
		accountTypeId,
		currentCompanyGrouping,
		dataCompanyGrouping,
		isOwnCompany,
		isSuperAdmin,
	]);

	return (
		<PageWrap>
			<AppMenu />
			<div className="relative min-w-0 flex-1 overflow-x-hidden pt-14 md:pt-0">
				{statusCode === 403 ? (
					<>
						<PaidProfileWrapper />
						<div className="relative top-1/2 h-[50vh]">
							<h1 className="mb-10 text-center text-black">
								Access Restricted
							</h1>
						</div>
						<AdditionalProfilesModal
							isOpen={isAdditionalProfileModalOpen}
							setIsOpen={setIsAdditionalProfileModalOpen}
							redirectUrl="/shared-companies"
						/>
					</>
				) : (
					<CompanyPreview companyId={companyId} />
				)}
			</div>
			<SideDraw />
		</PageWrap>
	);
};

const mapStateToProps = (state) => {
	return {
		company: state.search.activeCompany,
		loading: state.search.isLoading,
		isRequesting: state.search.activeCompany.isRequesting,
	};
};

export const Company = connect(mapStateToProps, {
	getCompanyView,
	getDocuments,
	getDocumentAccessRequests,
	getPastProjects,
})(CompanyComponent);
